import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import Loader from '../Loader/Loader';
import { faPlus, faTrash, faFileSignature, faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAppConfig } from '../../AppConfigProvider';
import PdfViewer from '../PdfViewer/PdfViewer';


const Docview = ({ load, setLoad, setIsImageUploaded, uId }) => {
  const appConfig = useAppConfig();
  const ss = useLocation().search;
  const did = new URLSearchParams(ss).get('did');
  const [doc, setDoc] = useState([]);
  const [docBillItems, setDocBillItems] = useState([]);
  const [isImg, setIsImg] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [publishStatus, setPublishStatus] = useState(false);

  let imgBill = appConfig.filesHost + doc.image;

  // Helper function to determine if file is an image based on extension
  const isImageFile = (imagePath) => {
    if (!imagePath) return false;
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
    return imageExtensions.test(imagePath);
  };



  const fetchDocss = useCallback(async () => {
    setLoad(true);
    await axios.get(`${appConfig.backendUrl}api/v1/bill/viewDoc/${did}`).then(function (response) {
      // Determine if file is image based on file extension
      if (isImageFile(response.data.image)) {
        setIsImg(true);
      } else {
        setIsImg(false);
      }
      if (response.data.publishStatus === "pending") {
        setPublishStatus(false);
        setIsDisabled(false);
      }
      if (response.data.publishStatus === "published") {
        setPublishStatus(true);
        setIsDisabled(true);
      }
      if (response.data.publishStatus === "error") {
        setPublishStatus(false);
        setIsDisabled(false);
      }
      setDoc(response.data);
      setDocBillItems(response.data.billItems);
      setLoad(false);
    });
  }, [appConfig.backendUrl, did, setLoad]);

  useEffect(() => {
    fetchDocss();
  }, [fetchDocss]);

  const navigate = useNavigate();

  const changeLoad = (vendorId) => {
    navigate(`/uploadedDocs/supplier?vid=${vendorId}`);
    // window.location.reload();
  }











  //for delete item from item list UI
  const handleDelete = (itemNo) => {
    const newItems = docBillItems.filter(docBillItem => docBillItem.itemNo !== itemNo);
    setDocBillItems(newItems);
    setDoc(bill => ({ ...bill, billItems: newItems }));
    console.log("Item deleted");
  }



  //for add new item row
  const addTableRows = async (e) => {
    e.preventDefault();
    let expenseAccName;
    await axios.get(`${appConfig.backendUrl}api/v1/qbuser/expense-accounts/${userIDD}`)
      .then(response => {
        expenseAccName = response.data[0].expenseAccountName;
      });

    const NewBillItem = {
      itemNo: docBillItems.length,
      itemName: '',
      productCode: '',
      quantity: '',
      unitPrice: '',
      price: '',
      expenseAccountName: expenseAccName
    }
    const updatedItems = [...docBillItems, NewBillItem];
    setDocBillItems(updatedItems);
    setDoc(bill => ({ ...bill, billItems: updatedItems }));
    console.log("New Item added", updatedItems);
  }

  //for line items value change
  const onFormBillItemsValueChange = (e, itemBill) => {
    console.log("Item::::::", itemBill);
    const itemProperty = e.target.id;
    const NewDataBillItems = docBillItems.map((item) => {
      if (item.itemNo === itemBill.itemNo) {
        item[itemProperty] = e.target.value;
        console.log("Filed Value change :", item[itemProperty]);
      }
      return item;
    });
    setDocBillItems(NewDataBillItems);
    setDoc(bill => ({ ...bill, billItems: NewDataBillItems }));
    console.log("Bill Items after Filed Value change :", NewDataBillItems);
    console.log("New Bill", doc);
  }

  //for bill details change
  const onFormVChange = (e) => {
    // BillOCRDetails[e.target.name]=e.target.value;
    setDoc(bill => ({ ...bill, [e.target.name]: e.target.value }));
    console.log("updated doc: ", doc);
  }





  const saveBill = () => {
    console.log("test");
    console.log("Load : ", load);
    setLoad(true);
    axios.put(`${appConfig.backendUrl}api/v1/bill`, doc).then(function (response) {
      console.log("test", doc);
      setTimeout(function () {
        setLoad(false);
        toast.success("Bill changes saved successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        console.log(response.data);
      }, 1000);
    }).catch(err => {
      setLoad(false);
      toast.error(`${err}`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
  }


  function handleSubmit(event) {
    event.preventDefault()
    saveBill();
  }

  const [payableAccounts, setPayableAccounts] = useState([]);
  const [expenseAccounts, setExpenseAccounts] = useState([]);

  const userIDD = uId;
  useEffect(() => {
    axios.get(`${appConfig.backendUrl}api/v1/qbuser/payable-accounts/${userIDD}`)
      .then(response => {
        setPayableAccounts(response.data);
        return axios.get(`${appConfig.backendUrl}api/v1/qbuser/expense-accounts/${userIDD}`);
      })
      .then(response => {
        setExpenseAccounts(response.data);
      })
      .catch(error => console.error('Error fetching payable-accounts:', error));
  }, [appConfig.backendUrl, userIDD]);

  if (load) {
    return <Loader />;
  }
  return (
    <div className='docview px-c'>
      <div className="position-relative">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-light  shadow-sm position-absolute d-flex align-items-center justify-content-center"
          style={{ top: '5px', left: '0', zIndex: 10, width: '44px', height: '33px', color: '#edeef0ff', transition: 'all 0.2s', backgroundColor: 'var(--main-color)', borderRadius: '50%', minWidth: '60px' }}
          title="Go Back"
          onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        <div className="page-header" style={{ marginBottom: '20px' }}>
          <h1 className="page-title">
            <FontAwesomeIcon icon={faFileSignature} />
            Document
          </h1>
          {/* <p className="page-subtitle mb-0">Review, edit, and verify</p> */}
        </div>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 bg-white p-3 rounded-4 shadow-sm">
        <h4 className="fw-bold mb-2 mb-md-0" style={{ color: '#2c3e50' }}>Invoice Details</h4>
        <div className="d-flex align-items-center gap-3 bg-light px-3 py-2 rounded-pill border">
          <span className="text-muted fw-bold" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Status:</span>
          <span className={`status-badge ${publishStatus ? 'published' : 'pending'}`} style={{ fontSize: '0.9rem', padding: '0.4rem 1.2rem' }}>
            {doc.publishStatus || (publishStatus ? 'PUBLISHED' : 'PENDING')}
          </span>
        </div>
      </div>

      <div className='row g-4' >
        {doc.billItems && (
          <div className="col-lg-7">
            <div className="card shadow-sm border-0 rounded-4 h-100">
              <div className="card-body p-4">
                <form className='BillForm w-100' id="docView" onSubmit={handleSubmit}>
                  <div className="row" style={{ padding: '0 10px ' }}>
                    {/* <div className="col">
              <label  className="form-label">Name</label>
              <input type="text" className="form-control" name="vendorName" onChange={(e)=>onFormVChange(e)}  aria-describedby="emailHelp" value={doc.vendorName}  disabled={isDisabled} required/> 
            <div className="col">
                <label  className="form-label">Address</label>
                <input type="text" className="form-control" name="vendorAddress" onChange={(e)=>onFormVChange(e)}   value={doc.vendorAddress}  disabled={isDisabled} required/>
            </div>
        </div> */}
                    <div className="row">
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Name</label>
                        <input type="text" className="form-control" name="vendorName" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" value={doc.vendorName} disabled={isDisabled} required />
                      </div>
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Address</label>
                        <input type="text" className="form-control" name="vendorAddress" onChange={(e) => onFormVChange(e)} value={doc.vendorAddress} disabled={isDisabled} required />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Invoice Date</label>
                        <input type="date" className="form-control" name="invoiceDate" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" value={doc.invoiceDate} disabled={isDisabled} required />
                      </div>
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Due Date</label>
                        <input type="date" className="form-control" name="dueDate" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" value={doc.dueDate} disabled={isDisabled} required />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Total</label>
                        <input type="number" step="0.01" className="form-control" name="totalAmount" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" value={doc.totalAmount} disabled={isDisabled} />
                      </div>
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Reference Number</label>
                        <input type="text" className="form-control" name="invoiceNo" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" defaultValue="" value={doc.invoiceNo} disabled={isDisabled} required />
                      </div>
                    </div>
                    <div className='row'>
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label">Payable Account</label>
                        <select className="form-select form-control" name="payableAccName" onChange={(e) => onFormVChange(e)}>
                          {payableAccounts.map(account => (
                            <option key={account.id} value={account.payableAccName} selected={account.payableAccName === doc.payableAccName}>{account.payableAccName}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* </div> */}
                  </div>

                  <div className="table-responsive mt-4 border rounded-3 shadow-sm">
                    <table className='modern-table w-100 m-0'>
                      <thead className="bg-light">
                        <tr>
                          <th style={{ minWidth: '150px' }}>Item</th>
                          <th style={{ minWidth: '150px' }}>Des.</th>
                          <th style={{ minWidth: '80px', textAlign: 'center' }}>Qty</th>
                          <th style={{ minWidth: '100px', textAlign: 'right' }}>Unit Price</th>
                          <th style={{ minWidth: '100px', textAlign: 'right' }}>Amount</th>
                          <th style={{ minWidth: '180px' }}>Expense Acc</th>
                          <th style={{ minWidth: '60px', textAlign: 'center' }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {docBillItems.map((item, key) => {
                          return <tr key={Number(item.itemNo)} className="align-middle">
                            <td className="p-2">
                              <input type="text" className="form-control form-control-sm" id="itemName" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.itemName} disabled={isDisabled} required />
                            </td>
                            <td className="p-2">
                              <input type="text" className="form-control form-control-sm" id="productCode" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.productCode} disabled={isDisabled} required />
                            </td>
                            <td className="p-2">
                              <input type="number" className="form-control form-control-sm text-center" id="quantity" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.quantity} disabled={isDisabled} required />
                            </td>
                            <td className="p-2">
                              <input type="number" step="0.01" className="form-control form-control-sm text-end" id="unitPrice" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.unitPrice} disabled={isDisabled} required />
                            </td>
                            <td className="p-2">
                              <input type="number" step="0.01" className="form-control form-control-sm text-end" id="price" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.price} disabled={isDisabled} required />
                            </td>
                            <td className="p-2">
                              <select className="form-select form-select-sm" id="expenseAccountName" onChange={(e) => onFormBillItemsValueChange(e, item)} required disabled={isDisabled}>
                                {expenseAccounts.map(account => (
                                  <option key={account.id} value={account.expenseAccountName} selected={account.expenseAccountName === item.expenseAccountName}>{account.expenseAccountName}</option>
                                ))}
                              </select>
                            </td>
                            <td className="p-2 text-center">
                              <button
                                type="button"
                                className='btn btn-light text-danger btn-sm rounded-circle'
                                onClick={() => handleDelete(item.itemNo)}
                                disabled={isDisabled}
                                title="Delete line item"
                                style={{ width: '30px', height: '30px', padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>

                        })}
                      </tbody>
                    </table>
                  </div>
                  {!publishStatus && <div className="mt-3 text-start"><button type="button" className="btn btn-outline-primary btn-sm fw-bold px-3 py-2 rounded-pill" onClick={addTableRows}><FontAwesomeIcon icon={faPlus} className="me-2" />Add Line Item</button></div>}
                </form>
              </div>
            </div>
          </div>
        )}
        <div className='col-lg-5'>
          <div className="card shadow-sm border-0 rounded-4 h-100">
            <div className="card-body p-4 d-flex flex-column">
              <h6 className="fw-bold mb-3 text-dark border-bottom pb-3">Uploaded Invoice</h6>
              <div className="flex-grow-1 doc-image-container bg-light rounded-3 overflow-hidden p-2" style={{ minHeight: '600px', position: 'relative' }}>
                {isImg ?
                  <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                    <img src={imgBill} alt="invoice" className='img-fluid shadow-sm rounded' style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
                  </div>
                  : <div className="w-100 h-100" style={{ minHeight: '600px' }}><PdfViewer fileURL={imgBill} /></div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Global Actions Bar at the bottom */}
      <div className="d-flex justify-content-end gap-3 mt-4 mb-5 pb-4">
        <button type="button" onClick={() => changeLoad(doc.vendorId)} className="btn-premium danger px-4" style={{ height: '44px', borderRadius: '50px' }}>
          Close
        </button>
        {!publishStatus && (
          <button type="submit" form="docView" className="btn-premium primary px-4" style={{ height: '44px', borderRadius: '50px' }}>
            <FontAwesomeIcon icon={faSave} className="me-2" />
            Save Changes
          </button>
        )}
      </div>
      <ToastContainer />
    </div>
  )
}

export default Docview